import React from "react";
import Navbar from "../Navbar/Navbar";
import "../Admin/Admin.css";
import Popup from "reactjs-popup";
function Admin() {
  return (
    <>
      <Navbar />
      <hr />
      <div className="adminspage">
        <div>
          <Popup
            trigger={<button className="btns"> Create Lectures </button>}
            modal
            nested
          >
            {(close) => (
              <div className="modal">
                <button className="close" onClick={close}>
                  &times;
                </button>
                <div className="header"> Create Lectures </div>
                <label className="lectlable">Type of Lecture</label>
                <br />
                <div className="content">
                  <select name="" id="">
                    <option value="">----</option>
                    <option value="DSA">DSA</option>
                    <option value="Coding">Coding</option>
                  </select>
                  <br />
                  <label className="lectlable">Lecture Name</label>
                  <br />
                  <input className="input" type="text" name="" id="" /> <br />
                  <label className="lectlable">Instructor Name</label>
                  <br />
                  <input className="input" type="text" name="" id="" /> <br />
                  <label className="lectlable">Date</label>
                  <br />
                  <input className="input" type="date" name="" id="" /> <br />
                  <label className="lectlable">Time</label>
                  <br />
                  <input className="input" type="time" name="" id="" /> <br />
                </div>
                <div className="actions">
                  <button
                    className="btns"
                    onClick={() => {
                      alert("Lecture created ");
                      close();
                    }}
                  >
                    Create
                  </button>
                </div>
              </div>
            )}
          </Popup>
        </div>
        <div>
          <Popup
            trigger={<button className="btns"> Create Assignments </button>}
            modal
            nested
          >
            {(close) => (
              <div className="modal">
                <button className="close" onClick={close}>
                  &times;
                </button>
                <div className="header"> Create Assignments </div>
                <div className="content">
                  <label className="lectlable">Assignment Name</label>
                  <br />
                  <input className="input" type="text" name="" id="" /> <br />
                  <label className="lectlable">Instructor Name</label>
                  <br />
                  <input className="input" type="text" name="" id="" /> <br />
                  <label className="lectlable">Type</label>
                  <br />
                  <select name="" className="select">
                    <option value="">select</option>
                    <option value="">FULL_STACK</option>
                    <option value="">FRONTEND</option>
                    <option value="">BACKEND</option>
                    <option value="">OJ</option>
                  </select>
                  <br />
                  <label className="lectlable">Date</label>
                  <br />
                  <input className="input" type="date" name="" id="" /> <br />
                  <label className="lectlable">Time</label>
                  <br />
                  <input className="input" type="time" name="" id="" /> <br />
                </div>
                <div className="actions">
                  <button
                    className="btns"
                    onClick={() => {
                      alert("Assignment added succesfully");
                      close();
                    }}
                  >
                    Create
                  </button>
                </div>
              </div>
            )}
          </Popup>
        </div>
      </div>
    </>
  );
}

export default Admin;
